import {
  CurrencyData,
  CurrencyServerData,
  generateCurrencyColumns,
  generateCurrencyData,
} from './currencyTable.data';
import CustomTable from '../../../../tables/CustomTable';
import { addCommasToNumbersAndRound } from '../../../../../utilities/numberFormatters';
import GridItem from '../../../../layout/GridComponents/GridItem';
import { useTheme } from '@mui/material';

interface CurrencyTableProps {
  currencyData: CurrencyServerData;
  isFetching: boolean;
}

const CurrencyTable = (props: CurrencyTableProps) => {
  const { currencyData, isFetching } = props;
  const tableData = generateCurrencyData(currencyData);
  const tableColumns = generateCurrencyColumns();
  const theme = useTheme();

  return (
    <GridItem xs={12} xl={6} card>
      <CustomTable<CurrencyData>
        options={{
          paging: false,
          exportButton: true,
        }}
        toolbarComponents={{
          otherComponents: [
            <div style={{ display: 'flex' }} key="toolbar_titles">
              <h3
                style={{
                  margin: '0.31rem',
                  marginBottom: 0,
                  fontSize: '1.12rem',
                  fontWeight: 'normal',
                  color: theme.palette.primary.main,
                }}
              >
                <span style={{ color: theme.palette.grey[600] }}>NAV: </span>
                {currencyData.base_currency}{' '}
                {isFetching ? '' : addCommasToNumbersAndRound(currencyData.nav)}
              </h3>
              <h3
                style={{
                  margin: '0.31rem',
                  marginBottom: 0,
                  fontSize: '1.12rem',
                  fontWeight: 'normal',
                  color: theme.palette.secondary.main,
                }}
              >
                <span style={{ color: theme.palette.grey[600] }}>
                  Position Date:{' '}
                </span>
                {isFetching ? '' : currencyData.selected_position_date}
              </h3>
            </div>,
          ],
        }}
        id="asset_class_currency_table"
        title="Currency"
        csvFields={tableColumns.map((col: any) => col.field)}
        showToolbar
        data={tableData}
        columns={tableColumns}
        loading={isFetching}
      />
    </GridItem>
  );
};

export default CurrencyTable;
